import { render, staticRenderFns } from "./FormatGroupTable.vue?vue&type=template&id=1143b32e&"
import script from "./FormatGroupTable.vue?vue&type=script&lang=ts&"
export * from "./FormatGroupTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports